import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sync-data-popup',
  templateUrl: './sync-data-popup.component.html',
  styleUrls: ['./sync-data-popup.component.css']
})
export class SyncDataPopupComponent {
  constructor(public dialogRef: MatDialogRef<SyncDataPopupComponent>) {}

  onLogout(): void {
    this.dialogRef.close('logout');
  }

  onContinue(): void {
    this.dialogRef.close('continue');
  }
}
